import { render, staticRenderFns } from "./VideoPlayerDialog.vue?vue&type=template&id=5dd64578&"
import script from "./VideoPlayerDialog.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports